export enum NUMBER_TYPE {
    'JAHR',
    'WAEHRUNG',
    'ANZ_RAEUME',
    'ANZAHL',
    'QUADRATMETER'
}
